import { render, staticRenderFns } from "./WanXiang.vue?vue&type=template&id=401b1222&scoped=true&"
import script from "./WanXiang.vue?vue&type=script&lang=js&"
export * from "./WanXiang.vue?vue&type=script&lang=js&"
import style0 from "./WanXiang.vue?vue&type=style&index=0&id=401b1222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401b1222",
  null
  
)

export default component.exports